import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

class CookiePolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const existing = document.getElementById('termly-jssdk');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    document.body.appendChild(script);
  }

  render() {
    return (
      <div>
        <PageBanner title='Cookie Policy' background='page-banner.jpg' />
        <div className='p-3'>
          <div
            name='termly-embed'
            data-id='27212a8b-14f3-4f5a-8951-55ddd4e3b727'
          ></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CookiePolicy;
